/* @flow */
import React from 'react'
import Basic from './basic'
import type { BasicPropsType, BasicStateType } from './basic'

class Error<Props: BasicPropsType, State: BasicStateType> extends Basic<Props, State> {
  render(): React$Element<*> | null {
    const { errorClassName, errorMessage } = this.props
    if (typeof errorMessage != 'string') return null
    return (
      <div className={this.classNames}>
        <p className={errorClassName}>{errorMessage}</p>
      </div>
    )
  }
}

export default Error
